module.exports = __webpack_public_path__ + "img/1440.47faa407.jpg";